import { render, staticRenderFns } from "./collectConfirmationTemplates.vue?vue&type=template&id=59233ff0&scoped=true"
import script from "./collectConfirmationTemplates.vue?vue&type=script&lang=js"
export * from "./collectConfirmationTemplates.vue?vue&type=script&lang=js"
import style0 from "./collectConfirmationTemplates.vue?vue&type=style&index=0&id=59233ff0&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59233ff0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('59233ff0')) {
      api.createRecord('59233ff0', component.options)
    } else {
      api.reload('59233ff0', component.options)
    }
    module.hot.accept("./collectConfirmationTemplates.vue?vue&type=template&id=59233ff0&scoped=true", function () {
      api.rerender('59233ff0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/EnduserDeclarationAdmin/collectConfirmationTemplates.vue"
export default component.exports